import { Stack, Typography } from '@mui/material';
import { Circle } from '@mui/icons-material';
import { Trans } from 'react-i18next';

import { ExternalGeoEvent } from 'shared/types';

type ExternalGeoEventRuleProps = {
  event: ExternalGeoEvent;
};

export const ExternalGeoEventRule = (
  props: ExternalGeoEventRuleProps,
): JSX.Element | null => {
  const { event } = props;

  if (!event.reasonNotProcessed) return null;

  return (
    <Stack alignItems="top" direction="row" gap={1} sx={{ py: 1, px: 2 }}>
      <Circle color="error" fontSize="small" />
      <Typography>
        <Trans
          i18nKey="externalGeoEvent.notProcessedRule"
          values={{ reasonNotProcessed: event.reasonNotProcessed }}
        >
          <b>Not created:</b> Older than 4 hours.
        </Trans>
      </Typography>
    </Stack>
  );
};
